import React from "react";
import { RadarChartSkeleton } from "./styles";

const LawsuitUpdatesRadarChartSkeleton = () => {
  return <RadarChartSkeleton />;
};

export default LawsuitUpdatesRadarChartSkeleton;
